import script from "./ViewHistoryRiskLogDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./ViewHistoryRiskLogDialog.vue?vue&type=script&lang=ts&setup=true"

import "./ViewHistoryRiskLogDialog.vue?vue&type=style&index=0&id=fb43d8ea&lang=scss&scoped=true"

import exportComponent from "E:\\workspace13\\aries-backend-front\\kailas-aries\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+comp_64f3209c872a893711b3e776f2c9ff1e\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb43d8ea"]])

export default __exports__